<template>
	<v-container fluid class="ma-0 pa-0">
		<!-- 공용성 고려: 카메라그룹 전용 Header (탭 분할 + 공유사용자추가 + 설정) -->
		<Header :tab="tab" @tabChange="tab = $event" @currentGroup="currentGroupFunc" />
		<v-col class="pa-0" id="main_content_maxwidthset" cols="12">
			<!-- 카메라리스트 탭 -->
			<template v-if="tab === 0">
				<CameraListTab />
			</template>
			<!-- 분할화면 탭 -->
			<template v-else>
				<SplitScreenTab />
			</template>
		</v-col>
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import Header from './Header.vue';
import CameraListTab from './CameraListTab.vue';
import SplitScreenTab from './SplitScreenTab.vue';
export default {
	components: {
		Header, CameraListTab, SplitScreenTab
	},
	mixins: [mixin.common],
	data: () => ({
		tab: 0, // 0: 카메라리스트, 1: 분할화면
		currentGroup: null,
	}),
	methods: {
		currentGroupFunc(group) {
			this.currentGroup = group;
		}
	}
}
</script>

<style lang="scss" scoped>
#camera_list_tab {
	min-height: 60vh;
}
#split_screen_tab {
	color: white;
	min-height: 60vh;
}
</style>
